import { GetterTree } from "vuex";
import { EventsQueueState, EventType, Group, SiteTreeNode } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<EventsQueueState, RootState> = {
	getActiveEvents: state => state.FilteredEvents,
	getFilteredEvents: state => state.FilteredEvents,
	getUnignoredHighPriority: (state: EventsQueueState, getters, rootState: RootState) => {
		// TODO merge as this getter is refactored to be cleaner in branch 2021-09-10_DD_51_High_Priority_Banner_Feedback
		const locallyIgnored = state.HighPriorityState.IgnoredEventIds;
		// Checks user has not ignored and the alarm is active and either in a filter or the user is in the all tab
		// Then sorts them to have oldest event first
		const nonIgnoredEvents = state.AllEvents.filter(event =>
			// Current user has not ignored this event
			!locallyIgnored.includes(event.eventID) &&
			(event.usersThatIgnored != null &&
				!event.usersThatIgnored.includes(rootState.User.userId)) &&
			// Event is an alarm and is high priority
			event.priority >= state.HighPriorityState.Threshold &&
			event.eventTypeID == 1 &&
			// Alarm is currently active
			event.inProcessing == false &&
			event.unParkAt == null &&
			event.isPermanentParked == false &&
			// Event is not the one the user is already processing (speeds up waiting for event queue to update)
			(rootState["siteMonitor"].EventDetails == null || event.eventID != rootState["siteMonitor"].EventDetails.eventID) &&
			// Alarm is either in a filter that the user has open or the user has the all tab open
			(event.inFilters != null || state.AlarmActiveFilter.filterId == -1) &&
			event.groupID);

		// Finally sort to have oldest first
		return nonIgnoredEvents.sort((a, b) => +new Date(a.created) - +new Date(b.created));
	},
	getFilteredEventById: state => (id: number) => state.FilteredEvents.filter(event => event.eventID === id)[0],
	getActiveFilterID: state => state.AlarmActiveFilter,
	getCountByType: state => (countType: string) => state.eventCountsByType[countType],
	getAlarmQueueFilterIDs: state => state.AlarmQueueFilterIDs,
	getLastUpdatedEvents: state => state.EventsLastUpdated,
	getAlarmQueueFilters: state => state.AlarmQueueFilters,
	getHoverEvent: state => state.HoverEvent,
	DisplayedEvent: state => state.DisplayedEvent,
	getManualPatrolShown: state => state.ManualPatrolShown,
	isNewFilterModalVisible: state => state.NewFilterModalShown,
	getActivityLogShown: state => state.ActivityLogShown,
	getManualActionShown: state => state.ManualActionShown,
	getSiteTree: state => state.SiteTree,
	getSiteTreeForSelectedTenant: state => (selectedTenant: number) => {
		return state.SiteTree.filter(node => node.group.groupID === selectedTenant);
	},
	getSelectedGroup: state => (state.selectedGroups.length > 0 ? state.selectedGroups[0] : {}),
	getSelectedGroups: state => state.selectedGroups,
	getGroupsFromTree: state => {
		const flattenTree = (node: SiteTreeNode): Group[] => {
			return [node.group, ...node.subGroups.flatMap(flattenTree)];
		};

		return state.SiteTree.flatMap(flattenTree);
	},
	getTreeSelectedGroup: state => state.treeSelectedGroup,
	getSearchSelectedGroup: state => state.searchSelectedGroup,
	getQueueMapBounds: state => state.queueMapBounds,
	getCurrentSort: state => state.CurrentSort,
	getProcessingError: state => state.processingError,
	routingGroups: state => state.RoutingGroups,
	alarmTags: state => state.AlarmTags,
	getLastEventHandled: state => state.lastEventHandled,
	getUserZone: state => state.userZone,
	serverEventTypes: state => state.ServerEventTypes,
	getHandlingEvent: state => state.HandlingEvent,
	getJoiningEventID: state => state.JoiningEventID,
	getTourNoteRequired: state => state.TourNoteRequired,
	getHideMapFlag: state => state.hideMapFlag,
	getBulkHandleShown: state => state.BulkHandleShown,
	getAllAlarmsSelected: state => state.AllAlarmsSelected,
	getAllAlarmsClicked: state => state.AllAlarmsClicked,
	getEndEventsDialogShown: state => state.EndEventsDialogShown,
	getSelectedAlarms: state => state.SelectedAlarms,
	getRefreshQueue: state => state.RefreshQueue,
	getSitesOnTestEvents: state => state.FilteredEvents.filter(event => event.eventTypeID === EventType.OnTest)
};
